export default "__VITE_ASSET__RWOBxdXm__"